import { toast } from 'react-toastify';
import { MessageData, MessageSubjectData } from 'types';
import { formatMillisecondsToHours, formatTimestamp } from 'helpers';
import { MESSAGES } from 'commons';

const DEFAULT_MESSAGE = {
  value: 'Ocorreu algum erro',
  type: 'alert',
};

const SUBJECT_KEY_NAME = 'subject';

const DATE_TYPES = ['startDate', 'endDate'];
const HOUR_TYPES = [
  'times',
  'initialRange',
  'finalRange',
  'closingTimes',
  'openingTimes',
];

function replaceSubject(message: string, subject: MessageSubjectData): string {
  const { subject: value, subjectType } = subject;

  const matchValue = `[${subjectType}]`;
  const replacerValue = (() => {
    const isDate = DATE_TYPES.includes(subjectType);

    if (isDate) return formatTimestamp(Number(value)).formattedDate;

    const isHour = HOUR_TYPES.includes(subjectType);

    if (isHour) {
      const values = value
        .split(',')
        .map((hour) => {
          const { hours, minutes } = formatMillisecondsToHours(Number(hour));

          return `${hours}:${minutes}`;
        })
        .join(', ');

      return values;
    }

    return value;
  })();

  return message.replace(matchValue, replacerValue);
}

export function messages(errors: MessageData) {
  const [error, ...rest] = errors;
  const subjectList = rest.filter((subject) =>
    Object.keys(subject).includes(SUBJECT_KEY_NAME)
  );

  const { errorCode } = error;

  if (!errorCode) {
    const { message, type } = error;

    return toast.error(message, {
      role: type,
      toastId: type,
      autoClose: false,
      hideProgressBar: false,
    });
  }

  const { value, type } = MESSAGES[errorCode] ?? DEFAULT_MESSAGE;

  const message = subjectList.reduce((previousMessage, subject) => {
    return replaceSubject(previousMessage, subject);
  }, value);

  switch (type) {
    case 'error':
      toast.error(message, {
        role: type,
        toastId: type,
        autoClose: false,
        hideProgressBar: false,
      });

      return;

    case 'success':
      toast.dismiss();
      toast.success(message, { role: type, toastId: type, delay: 500 });

      return;

    case 'alert':
      toast.warn(message, { role: type, toastId: type });

      return;

    default:
      toast.dismiss();
      toast(message);

      return;
  }
}
